import { css } from 'react-emotion'

const styles = {
  videoItemWrap: css({
    position: 'relative',
    zIndex: '2'
  }),
  mask: css({
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    flex: 1,
    zIndex: 9
  }),
  infoWrap: css({
    width: '100%',
    background: 'white',
    padding: '10px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
  }),
  videoImg: css({
    background: '#ccc !important',
    height: '100%',
    width: '100%'
  }),
  linkImages: css({
    display: 'block',
    width: '100%',
    minHeight: '160px',
    height: '18vh',
    color: '#555',
    '&:hover': css({
      color: '#555'
    })
  }),
  link: css({
    color: '#555',
    width: '88%',
    '&:hover': css({
      color: '#555'
    })
  }),
  title: css({
    fontSize: '14px',
    textOverflow: 'ellipsis',
    wordBreak: 'keep-all',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    maxWidth: '80%',
  }),
  user: css({
    color: '#999',
    fontSize: '12px'
  }),
  dot: css({
    marginRight: '4px',
    marginLeft: '4px',
    fontSize: '14px',
    color: '#999'
  }),
  date: css({
    fontSize: '12px',
    color: '#999'
  }),
  dropdown: css({
    alignSelf: 'center'
  }),
  statusDropDown: css({
    position: 'absolute',
    top: '3px',
    left: '3px',
    zIndex: 3
  })
}

export default styles



// WEBPACK FOOTER //
// ./src/Pages/Videos/VideoItemStyles.js